import AppConfiguration from "../dataProvider/config";
import axios from "axios";
import { get, isNull, isUndefined, omitBy } from "lodash";

let ghtkTokenStr = localStorage.getItem("ghtk-token-storage");

const requestHeader = {
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,OPTIONS",
  "Access-Control-Allow-Headers":
    "Origin,Authorization,Content-Type,Accept,User-Agent,Cache-Control,Keep-Alive,X-Requested-With,If-Modified-Since",
  timeout: 180000
};

const fileRequestHeader = {
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,OPTIONS",
  "Access-Control-Allow-Headers":
    "Origin,Authorization,Content-Type,Accept,User-Agent,Cache-Control,Keep-Alive,X-Requested-With,If-Modified-Since",
  "Content-Type": "multipart/form-data",
  timeout: 180000
};

if (ghtkTokenStr) {
  let ghtkTokenStorage = JSON.parse(ghtkTokenStr);
  let accessToken = get(ghtkTokenStorage, "accessToken.accessToken", "");
  if (accessToken) {
    requestHeader["Authorization"] = `Bearer ${accessToken}`;
    fileRequestHeader["Authorization"] = `Bearer ${accessToken}`;
  }
}
const axiosConfig = {
  baseURL: AppConfiguration.apiBaseMap,
  headers: requestHeader
};

const axiosFileConfig = {
  baseURL: AppConfiguration.apiBaseMap,
  headers: fileRequestHeader
};

const axiosConfigBlob = {
  baseURL: AppConfiguration.apiBaseMap,
  headers: requestHeader,
  responseType: "arraybuffer"
};

const axiosInstance = axios.create(axiosConfig);
const axiosFileInstance = axios.create(axiosFileConfig);
const axiosBlobInstance = axios.create(axiosConfigBlob);
axiosBlobInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const errRes = error.response;
    if (errRes) return errRes;
  }
);

export default {
  browserSmartLock(params) {
    let api = `/device/v1/smart-lock/search`;
    return axiosInstance.get(api, {
      params: omitBy(params, v => isUndefined(v) || isNull(v) || v === "")
    });
  },
  addSmartLock(data) {
    let api = `/device/v1/smart-lock/cabinet`;
    return axiosInstance.post(api, data);
  },
  editSmartLock(data) {
    let api = `/device/v1/smart-lock/cabinet`;
    return axiosInstance.put(api, data);
  },
  deleteSmartLock(id) {
    let api = `/device/v1/smart-lock/cabinet`;
    return axiosInstance.delete(api, { params: { id } });
  },
  getSmartLock(params) {
    let api = `/device/v1/smart-lock/find`;
    return axiosInstance.get(api, { params });
  },
  getModuleType(params) {
    let api = `/device/v1/smart-lock/module/type`;
    return axiosInstance.get(api, { params });
  },
  addSmartLockRepairLog(data) {
    let api = `/device/v1/smart-lock/repair-log`;
    return axiosFileInstance.post(api, data);
  },
  getSmartLockRepairLog(params) {
    let api = `/device/v1/smart-lock/get-repair-logs`;
    return axiosInstance.get(api, { params });
  },
  deleteSmartLockRepairLog(id) {
    let api = `/device/v1/smart-lock/delete-repair-logs`;
    return axiosInstance.delete(api, { params: { id } });
  },

  // Quản lý module smartlock
  addSmartLockModule(data) {
    let api = `device/v1/smart-lock/module/type`;
    return axiosInstance.post(api, data);
  },
  updateSmartLockModule(data) {
    let api = `device/v1/smart-lock/module/type`;
    return axiosInstance.put(api, data);
  },
  deleteSmartLockModule(data) {
    let api = `device/v1/smart-lock/module/type`;
    return axiosInstance.delete(api, { data });
  },
  getSmartLockInterface() {
    let api = `/device/v1/smart-lock/interface-types`;
    return axiosInstance.get(api);
  },

  exportSmartLockCabinet(params) {
    let api = `/device/v1/smart-lock/export-cabinet-list`;
    return axiosBlobInstance.get(api, { params });
  },

  getLinkDownloadEnterpriseReport(params) {
    let api = `tracker/report/enterprise/driver-driving-continuous/export`;
    return axiosBlobInstance.get(api, { params });
  },

  getLinkDownloadEnterpriseReport48H(params) {
    let api = `tracker/report/enterprise/48h/export`;
    return axiosBlobInstance.get(api, { params });
  },

  getLinkDownloadEnterpriseReportType9(params) {
    let api = `tracker/report/enterprise/driver-activity-summary/download`;
    return axiosBlobInstance.get(api, { params });
  }
};
